__turbopack_context__.v({
  "dropzone": "file-upload-box-module-scss-module__jwniSq__dropzone",
  "icon": "file-upload-box-module-scss-module__jwniSq__icon",
  "input": "file-upload-box-module-scss-module__jwniSq__input",
  "message": "file-upload-box-module-scss-module__jwniSq__message",
  "root": "file-upload-box-module-scss-module__jwniSq__root",
  "title": "file-upload-box-module-scss-module__jwniSq__title",
});
